var map = {
	"./Arsenal.png": 472,
	"./Aston Villa.png": 829,
	"./Atalanta.png": 308,
	"./Atleti.png": 855,
	"./B.Dortmund.png": 769,
	"./Barcelona.png": 753,
	"./Bayern Munchen.png": 897,
	"./Benfica.png": 782,
	"./Bologna.png": 108,
	"./Brest.png": 582,
	"./Celtic.png": 236,
	"./Club Brugge.png": 394,
	"./Crvena Zvezda.png": 251,
	"./Feyenoord.png": 179,
	"./GNK Dinamo.png": 324,
	"./Girona.png": 866,
	"./Inter.png": 120,
	"./Juventus.png": 174,
	"./Leipzig.png": 882,
	"./Leverkusen.png": 134,
	"./Lille.png": 592,
	"./Liverpool.png": 764,
	"./Man City.png": 501,
	"./Milan.png": 81,
	"./Monaco.png": 581,
	"./PSV.png": 681,
	"./Paris.png": 395,
	"./Real Madrid.png": 201,
	"./S.Bratislava.png": 506,
	"./Salzburg.png": 880,
	"./Shakhtar.png": 524,
	"./Sparta Praha.png": 447,
	"./Sporting CP.png": 229,
	"./Sturm Graz.png": 413,
	"./Stuttgart.png": 986,
	"./Young Boys.png": 777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;